export const updateCustomerAccount = (state, action) => ({
  ...state,
  account: {
    ...state.account,
    ...action.payload,
  },
});
